import React, { useContext } from "react";
import * as PropTypes from "prop-types";
import TotalPrice from "../common/TotalPrice";
import PromoCode from "../common/PromoCode";
import {buyNowContext} from "../BuyNow";
import ShippingPrice from "../common/ShippingPrice";
import SalesTaxPrice from "../common/SalesTaxPrice";
import ReferralCode from "../common/ReferralCode";
import {formattedNextChargeDate} from "../../utils/orderHelper";
import RecurringPlanPrice from "../common/RecurringPlanPrice";
import {PRODUCT_CATEGORIES} from "../../../../constants";
import ProductPrice from "../common/ProductPrice";
import LineItemDisplay from "../common/LineItemDisplay";

const OrderSummary = ({ showOrderSummary, showInMobileOnly }) => {
  const { lineItems, promoCode, shippingStageState, quantitiesEnabled } = useContext(buyNowContext);

  const scaleLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.SCALE);
  const planLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MEMBERSHIP);

  // The primary class used for text within the order summary.
  const primaryTextClass = "plan-main-txt text-dark mb-0 pb-0 fw-bolder";

  return (
    <React.Fragment>
      <div
        id={"summary"}
        className={`w-100 vh-100 bg-dark d-lg-none order-summary-mobile order-summary-mobile-background ${showOrderSummary ? 'd-block' : 'd-none'}`}/>
      <div
        className={`col-12 col-lg-4 p-0 border rounded-sm shadow bg-white border-light order-summary-mobile ${showOrderSummary ? 'd-block' : 'd-none'} ${showInMobileOnly? '' : 'd-lg-block'} order-summary-container`}>
        <div className="p-3">
          <p className="header-txt text-dark fw-bold mb-0 mt-3 mt-lg-0">Order summary</p>

          {lineItems.map(lineItem => <LineItemDisplay key={lineItem.product.id} lineItem={lineItem} textClass={primaryTextClass} />)}

          {scaleLineItem &&
            <div className="row justify-content-between">
              <div className="col-6 d-flex flex-column">
                <p className={primaryTextClass}>Shipping</p>
                <p className="sub-txt text-muted">{shippingStageState.shippingMethod.timeFrame}</p>
              </div>
              <div className="col-2 text-center">
                {quantitiesEnabled && <p className={primaryTextClass}>{scaleLineItem.quantity}</p>}
              </div>
              <div className="col-4 text-end">
                <p className={primaryTextClass}>${<ShippingPrice/>}</p>
              </div>
            </div>
          }

          <div className="row justify-content-between pb-3">
            <div className="col-9 d-flex flex-column">
              <p className={primaryTextClass}>Sales tax</p>
            </div>
            <div className="col-3 text-end">
              <p className={primaryTextClass}>${<SalesTaxPrice />}</p>
            </div>
          </div>

          <PromoCode hideDecimalIfWhole={false} />
          <ReferralCode />

          <div className="row justify-content-between h-auto">
            <div className="col-8 d-flex flex-column">
              <p className="plan-price-txt text-dark mb-0 pb-0 fw-bold">Total</p>
            </div>
            <div className="col-4 text-end">
              <p className="plan-price-txt fw-bold text-dark pb-0 mb-0">${<TotalPrice />}</p>
            </div>
          </div>
        </div>

        {planLineItem && planLineItem.product.recurringPlan &&
          <div className="position-absolute mt-3 d-none d-lg-block">
            <p className="sub-txt">
              {`Your subscription will automatically renew unless you cancel before ${formattedNextChargeDate(planLineItem.product, promoCode)}. Your cancellation will take effect at the end of your current billing cycle.`}
            </p>
          </div>
        }

      </div>
    </React.Fragment>
  )
};

OrderSummary.propTypes = {
  showOrderSummary: PropTypes.bool.isRequired,
  showInMobileOnly: PropTypes.bool
};

OrderSummary.defaultProps = {
  showInMobileOnly: false
}

export default OrderSummary;